import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {ArrUtil} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Select} from '@components/common/base/select'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {getMultiSelectText} from '@components/common/dropdown-list/dropdown-list'
import {UsersTable} from '@components/common/users-table/users-table'
import {cn} from '@containers/html-utils'
import {getUsers} from './utils/get-users'
import {getUsersOptions} from './utils/get-users-options'

type Props = {
  selectedUserIds: DataObjectId[]
  onDefaultStateChanged: (key: DataObjectId[]) => void
  disabled?: boolean
  board: Hub
  className?: string
}

export const DropdownWithUsers = (props: Props) => {
  const {selectedUserIds = [], onDefaultStateChanged, disabled, board} = props
  const [showed, setShowed] = useState<boolean>(false)

  const toggleUsers = (userKeys: DataObjectId[]) => {
    const newSelectedUserIds = ArrUtil.xorBy(selectedUserIds, userKeys, x => x)
    onDefaultStateChanged([...newSelectedUserIds])
  }

  const users = getUsers(board)
  const usersOptions = getUsersOptions(users)

  const dropdownButtonText = getMultiSelectText({
    value: selectedUserIds,
    options: usersOptions,
    placeholder: Lang.msg.myStickers.selectUser
  })

  return (
    <Select
      className={cn('!w-[380px]', props.className)}
      variant="new"
      open={showed}
      onOpenChange={setShowed}
      disabled={disabled}
      content={
        <DropdownContent className="w-392 h-304" header={Lang.msg.coworkers}>
          <UsersTable
            className="h-full"
            users={users}
            useCheckbox={true}
            selected={selectedUserIds}
            onToggled={toggleUsers}
          />
        </DropdownContent>
      }
    >
      {dropdownButtonText}
    </Select>
  )
}
